import React, {useState, useRef} from "react";
import {Controller} from "react-hook-form";
import {useLocation, useNavigate} from "react-router";
import {Calendar} from "react-date-range";
import {Popper} from "@mui/material";
import moment from "moment";
import {enGB} from "date-fns/locale";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import {Svg} from "assets";
import {newDateWithoutUtcCalendar, SaveParams} from "utils";


export const DateCalendarForm2 = ({
                                      label,
                                      control,
                                      name,
                                      rules,
                                      max,
                                      min,
                                      closeModal = true,
                                      disabled,
                                  }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const inputRef = useRef(null);
    const location = useLocation();
    const navigate = useNavigate();
    const open = Boolean(anchorEl);
    const id = open ? "simple-popper" : undefined;
    const info = location?.state;

    const customLocale = {
        ...enGB,
        options: {
            ...enGB.options,
            weekStartsOn: 0,
        },
    };

    const handleClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const getNestedError = (obj, path) => {
        return path.split(".").reduce((acc, part) => acc && acc[part], obj);
    };

    const handleToday = (onChange) => {
        const today = moment().format("YYYY-MM-DD");
        onChange(today);
        SaveParams(location?.pathname, navigate, {...info, [name]: today});
        if (closeModal) setAnchorEl(null);
    };

    return (
        <Controller
            control={control}
            name={name}
            rules={rules}
            render={({field, formState: {errors}}) => {
                const error = getNestedError(errors, name);
                const hasError = !!error?.message;

                if (hasError && inputRef.current) {
                    inputRef.current.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                    });
                }

                const handleDateChange = (date) => {
                    field.onChange(date);
                    SaveParams(location?.pathname, navigate, {...info, [name]: date});
                };

                const currentValue = (info?.[name] || field.value) && moment(info?.[name] || field?.value).format("dd MMM DD, YYYY");
                const currentDate = field?.value ? moment(field.value, "YYYY-MM-DD") : moment();


                const handlePrevDay = (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const prevDay = currentDate && currentDate.clone().subtract(1, "day").format("YYYY-MM-DD");
                    handleDateChange(prevDay)
                };

                const handleNextDay = (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const nextDay = currentDate && currentDate.clone().add(1, "day").format("YYYY-MM-DD");
                    handleDateChange(nextDay)
                };

                return (
                    <>
                        <div className="date-calendar-wrapper">
                            {label && (
                                <p className="date-input-title">
                                    {`${label}${rules?.required ? "*" : ""}`}
                                </p>
                            )}
                            <div className='date-calendar-block'>
                                <button
                                    ref={(el) => {
                                        field.ref(el);
                                        inputRef.current = el;
                                    }}
                                    disabled={disabled}
                                    onClick={handleClick}
                                    className={`date-calendar-2-main-button`}
                                    aria-describedby={id}
                                    type={"button"}
                                >
                                    <button
                                        className='date-calendar-2-main-button_arrow left'
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            handlePrevDay(e)
                                        }}>
                                        <Svg.ArrowRightSvg className='date-calendar-2-main-button_arrow'/>
                                    </button>

                                    <Svg.CalendarSvg className='date-calendar-2-main-calendar'/>

                                    <p className='date-calendar-2-main-button_text'>
                                        {currentValue}
                                    </p>

                                    <button
                                        className='date-calendar-2-main-button_arrow'
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            handleNextDay(e)
                                        }}>
                                        <Svg.ArrowRightSvg/>
                                    </button>
                                </button>

                                <button
                                    className='date-calendar-2-main-button' style={{width: 'fit-content'}}
                                    onClick={() => handleToday(field.onChange)}
                                >
                                    <p className='date-calendar-2-main-button_text'>
                                        Today
                                    </p>
                                </button>
                            </div>


                            <Popper
                                id={id}
                                open={open}
                                anchorEl={anchorEl}
                                className={"modal-custom-date-selector-box no-clear-btn"}
                                placement="bottom-start"
                                style={{position: "absolute", zIndex: 1400}}
                            >
                                <Calendar
                                    date={info?.[name] || field?.value ? moment(info?.[name] || field?.value).toDate() : null}
                                    onChange={(date) => {
                                        const formattedDate = moment(date).format("YYYY-MM-DD");
                                        handleDateChange(formattedDate);
                                        if (closeModal) setAnchorEl(null)
                                    }}
                                    locale={customLocale}
                                    maxDate={max ? newDateWithoutUtcCalendar(max) : undefined}
                                    minDate={min ? newDateWithoutUtcCalendar(min) : undefined}
                                />
                            </Popper>
                            {open && (
                                <div className="beck-drop" onClick={() => setAnchorEl(null)}/>
                            )}
                        </div>
                    </>
                );
            }}
        />
    );
};
